import { getData, putData } from '../../../shared/api/core';

export const getVesselSchedules = (params) =>
  getData(`/vessel/vesselSchedules?${new URLSearchParams(params).toString()}`);

export const updateVesselSchedule = (id, vesselSchedule) =>
  putData(`/vessel/vesselSchedule/${id}`, vesselSchedule);

export const getVesselScheduleHistory = (vesselScheduleId) =>
  getData(`/vessel/${vesselScheduleId}/history`);
